import React, { useEffect, useState, useMemo } from 'react';
import AdminNavbar from '../components/adminNavbar';

import 'chart.js/auto';
import { Bar, Doughnut } from 'react-chartjs-2';

const BASE_API_URL = process.env.REACT_APP_API_URL;
export default function AdminDashboard({ setToken }) {

    const [contributions, setContributions] = useState([]);
    const [expenses, setExpenses] = useState([]);

    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const normalizeDate = (dateStr) => {
        const [day, month, year] = dateStr.split('-');
        return new Date(`${year}-${month}-${day}`);
    };

    const filteredContributions = useMemo(() => {
        if (!fromDate && !toDate) return contributions;

        return contributions.filter(c => {
            const donationDate = normalizeDate(c.DonationDate);
            const from = fromDate ? new Date(fromDate) : null;
            const to = toDate ? new Date(toDate) : null;

            if (from && donationDate < from) return false;
            if (to && donationDate > to) return false;

            return true;
        });
    }, [contributions, fromDate, toDate]);

    const serviceDonationData = useMemo(() => {
        if (!filteredContributions.length) {
            return {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: [],
                    },
                ],
            };
        }

        const serviceTotals = {};

        filteredContributions.forEach(donation => {
            donation.DonationServices?.forEach(service => {
                serviceTotals[service.ServiceName] =
                    (serviceTotals[service.ServiceName] || 0) +
                    Number(service.ServiceDonationAmount || 0);
            });
        });

        return {
            labels: Object.keys(serviceTotals),
            datasets: [
                {
                    data: Object.values(serviceTotals),
                    backgroundColor: [
                        '#FF6384',
                        '#36A2EB',
                        '#FFCE56',
                        '#8BC34A',
                        '#9C27B0',
                    ],
                },
            ],
        };
    }, [filteredContributions]);


    const donationByDateData = useMemo(() => {
        if (!filteredContributions.length) {
            return {
                labels: [],
                datasets: [
                    {
                        label: 'Total Donation Amount',
                        data: [],
                        backgroundColor: '#2196F3',
                    },
                ],
            };
        }

        const totalsByDate = {};

        filteredContributions.forEach(d => {
            totalsByDate[d.DonationDate] =
                (totalsByDate[d.DonationDate] || 0) +
                Number(d.DonationAmount || 0);
        });

        return {
            labels: Object.keys(totalsByDate),
            datasets: [
                {
                    label: 'Total Donation Amount',
                    data: Object.values(totalsByDate),
                    backgroundColor: '#2196F3',
                },
            ],
        };
    }, [filteredContributions]);



     useEffect(() => {
          const fetchData = async () => {
               try {
                   const response = await fetch(`${BASE_API_URL}/AdminDonations`);
                    const data = await response.json();
                   setContributions(data.reverse()); // Reverse the order of donations
               } catch (error) {
                    console.error('Error fetching data:', error);
               }
          };
         const fetchExpensesData = async () => {
             try {
                 const response = await fetch(`${BASE_API_URL}/Expenses`);
                 const data = await response.json();
                 setExpenses(data.reverse()); // Reverse the order of donations
             } catch (error) {
                 console.error('Error fetching data:', error);
             }
         };
         fetchData();
         fetchExpensesData();
     }, []);

     return (
          <>
               <AdminNavbar setToken={setToken} />
               <div className="events">
                    <div className="res-container sm-pt-10">
                         <div className="row admin-chart">
                              <div className="col-6">
                                   <div className="card p-0 mb-20">
                                        <div className="row">
                                             <div className="col-md-12 p-0">
                                                  <div className="card common-card">
                                            <div className="card-header d-flex jc-sb pb-0">
                                                 <h3 className="head m-0">Service-wise Donation Distribution</h3>
                                                 {/*<div style={{ display: 'flex', gap: '20px', marginBottom: '30px' }}>*/}
                                                 {/*    <div>*/}
                                                 {/*        <label>From Date</label><br />*/}
                                                 {/*        <input*/}
                                                 {/*            type="date"*/}
                                                 {/*            value={fromDate}*/}
                                                 {/*            onChange={e => setFromDate(e.target.value)}*/}
                                                 {/*        />*/}
                                                 {/*    </div>*/}

                                                 {/*    <div>*/}
                                                 {/*        <label>To Date</label><br />*/}
                                                 {/*        <input*/}
                                                 {/*            type="date"*/}
                                                 {/*            value={toDate}*/}
                                                 {/*            onChange={e => setToDate(e.target.value)}*/}
                                                 {/*        />*/}
                                                 {/*    </div>*/}
                                                 {/*</div>*/}
                                             </div>

                                                 {/*      <div className="card-body row" style={{ paddingTop: '15px', paddingBottom: '0px' }}>*/}
                                                 {/*{serviceDonationData.datasets?.length > 0 && (*/}
                                                 {/*    <Doughnut data={serviceDonationData} />*/}
                                                 {/*)}*/}
                                             {/*      </div>*/}
                                             <div>
                                                <br/>
                                                 <Doughnut data={serviceDonationData} />
                                             </div>
                                                  </div>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                              <div className="col-6">
                                   <div className="card p-0 mb-20">
                                        <div className="row">
                                             <div className="col-md-12 p-0">
                                                  <div className="card common-card">
                                                       <div className="card-header d-flex jc-sb pb-0">
                                                 <h3 className="head m-0">Donation Amount by Date</h3>
                                                       </div>
                                                       <div className="card-body row" style={{ paddingTop: '15px', paddingBottom: '0px' }}>
                                                 {donationByDateData.datasets?.length > 0 && (
                                                     <Bar data={donationByDateData} />
                                                 )}
                                                       </div>
                                                  </div>
                                             </div>
                                        </div>
                                   </div>
                         </div>

                     </div>

                         <div className="row">
                              <div className="col-6">
                                   <div className="card p-0 mb-20">
                                        <div className="row">
                                             <div className="col-md-12 p-0">
                                                  <div className="card common-card">
                                                       <div className="card-header d-flex jc-sb pb-0">
                                                            <h3 className="head m-0">Last Five Donations</h3>
                                                       </div>
                                                       <div className="card-body row" style={{ paddingTop: '15px', paddingBottom: '0px' }}>
                                                            <div className='overflow-scroll'>
                                                                 <table className="table">
                                                                      <thead>
                                                                           <tr>
                                                                                {/* <th>Order ID</th> */}
                                                                                <th>Contributor Name</th>
                                                                                <th>Contribution Date</th>
                                                                                <th>Contribution Type</th>
                                                                                {/* <th>Payment Method</th> */}
                                                                                {/* <th>Transaction Number</th> */}
                                                                                <th>Contribution Amount</th>
                                                                                <th>Payment Status</th>
                                                                           </tr>
                                                                      </thead>
                                                                      <tbody>
                                                                           {contributions.slice(0, 5).map((contribution) => (
                                                                                <tr key={contribution.DonationOrderId}>
                                                                                     {/* <td>{contribution.DonationOrderId}</td> */}
                                                                                     <td>{contribution.DonarName}</td>
                                                                                     <td>{contribution.DonationDate}</td>
                                                                                     <td>{contribution.DonationType}</td>
                                                                                     {/* <td>{contribution.PaymentMethod}</td> */}
                                                                                     {/* <td>{contribution.TransactionNumber}</td> */}
                                                                                     <td>{contribution.DonationAmount}</td>
                                                                                     <td>{contribution.PaymentStatus || 'Pending'}</td>
                                                                                </tr>
                                                                           ))}
                                                                      </tbody>
                                                                 </table>
                                                            </div>
                                                       </div>
                                                  </div>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                              <div className="col-6">
                                   <div className="card p-0 mb-20">
                                        <div className="row">
                                             <div className="col-md-12 p-0">
                                                  <div className="card common-card">
                                                       <div className="card-header d-flex jc-sb pb-0">
                                                            <h3 className="head m-0">Last Five Expenses</h3>
                                                       </div>
                                                       <div className="card-body row" style={{ paddingTop: '15px', paddingBottom: '0px' }}>
                                                 <div className='overflow-scroll'>
                                                     <table className="table">
                                                         <thead>
                                                             <tr>
                                                                 <th>Type</th>
                                                                 <th>Amount</th>
                                                                 <th>Description</th>
                                                                 <th>Date</th>
                                                                 <th>By whom</th>
                                                             </tr>
                                                         </thead>
                                                         <tbody>
                                                             {expenses.slice(0, 5).map((expense) => (
                                                                 <tr >
                                                                     <td>{expense.expenseType===1?"Expense":"Spend"}</td>
                                                                     <td>{expense.expenseAmount}</td>
                                                                     <td>{expense.expenseDescription}</td>
                                                                     <td>{expense.expenseDate}</td>
                                                                     <td>{expense.expenseBy}</td>
                                                                 </tr>
                                                             ))}
                                                         </tbody>
                                                     </table>
                                                 </div>
                                                       </div>
                                                  </div>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
          </>
     );
}

